<template>
  <footer class="footer">
    <span class="text-mid">© Porsche Croatia</span>
  </footer>
</template>

<style
  scoped
  lang="scss"
>
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  color: var(--color-text-primary);

  @include breakpoint-up("sm") {
    height: 68px;
    padding-inline: clamp-bp("sm", "xl", 30, 39);
    justify-content: flex-end;
  }
}
</style>
